import { useRef, useContext } from 'react'
import classNames from 'classnames'
import { createUseStyles } from 'react-jss'
import { useRaf } from '@/components/Handlers'
import { Context as ScrollbarContext } from '@/context/scrollbar'
import style from './style'

const useStyles = createUseStyles(style)

const RollTextOnScroll = ({
  text,
  reverse,
}) => {
  const classes = useStyles()
  const wrapperRef = useRef()
  const rootRef = useRef()
  const containerRef = useRef()
  const { scroll } = useContext(ScrollbarContext)

  useRaf(() => {
    if (rootRef.current) rootRef.current.style.transform = `translate3d(${!reverse ? '' : '-'}${scroll.current.y * 0.3}px, 0px, 0px)`
  })

  return (
    <div
      ref={wrapperRef}
      className={classNames({
        [classes.root]: true,
        [classes.reverse]: reverse,
      })}
    >
      <div
        ref={rootRef}
        className={classes.groupContainer}
      >
        <div
          ref={containerRef}
          className={classes.railContainer}
        >
          <div className={classes.railTrack}>
            <div className={classes.text}>
              <span dangerouslySetInnerHTML={{ __html: text }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

RollTextOnScroll.defaultProps = {
  reverse: false,
}

export default RollTextOnScroll
